import type { RxJsonSchema } from 'rxdb';
import type { SupplierDocType } from '../types/supplier';

export const supplierSchema: RxJsonSchema<SupplierDocType> = {
  version: 0,
  primaryKey: 'id',
  type: 'object',
  properties: {
    id: { type: 'string', maxLength: 36 },
    name: { type: 'string', maxLength: 100 },
    code: { type: 'string', maxLength: 20 },
    contactPerson: { type: 'string', maxLength: 100 },
    phone: { type: 'string', maxLength: 20 },
    email: { type: 'string', maxLength: 100 },
    address: { type: 'string', maxLength: 500 },
    notes: { type: 'string' },
    isActive: { type: 'boolean', default: true },
    createdAt: { type: 'string' },
    updatedAt: { type: 'string' },
    _deleted: { type: 'boolean', default: false },
  },
  required: ['id', 'name', 'code', 'createdAt', 'updatedAt'],
};
